import { ComponentChildren, h } from 'preact'

const Switcher = ({ disable, on, onChange, label, meta, customClass = '', labelCustomClass = '' }: {
  disable?: boolean
  on?: boolean
  onChange: () => void
  label?: ComponentChildren
  meta?: string
  customClass?: string
  labelCustomClass?: string
}) => <label className={`${customClass} font-weight-normal preact-switch switcher${disable ? ' disable' : ''}`}>
  <div className={'control-switcher' + (on ? ' on' : '')}>
    <a className='toggle' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'><i className='icon-handler' /></a>
    <a className='ui-on' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'><i className='icon-check-slim' /></a>
    <a className='ui-off' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'><i className='icon-cross-slim' /></a>
  </div>
  <div className={`${labelCustomClass}`}>{label}</div>
  {meta && <div className='metadata'>{meta}</div>}
</label>

export default Switcher
